import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SupabaseCompany {
  slug: string;
  logoUrl: string | null;
  employees: string;
  category: string;
  description: string | null;
  url: string | null;
  legacySlug: string | null;
  pages: {
    subslug: string;
    pricingPageUrl: string | null;
    screenshotUrl: string | null;
    screenshotUrlVersion: string | null;
  }[];
}

interface SupaCompaniesState {
  companies: SupabaseCompany[];
  loading: boolean;
  error: string | null;
  uniqueCategories: string[];
  uniqueEmployees: string[];
}

const initialState: SupaCompaniesState = {
  companies: [],
  loading: false,
  error: null,
  uniqueCategories: ['All'],
  uniqueEmployees: ['All'],
};

const supaCompaniesSlice = createSlice({
  name: 'supaCompanies',
  initialState,
  reducers: {
    setSupaCompanies: (state, action: PayloadAction<SupabaseCompany[]>) => {
      state.companies = action.payload;
    },
    setSupaLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSupaError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setSupaUniqueCategories: (state, action: PayloadAction<string[]>) => {
      state.uniqueCategories = action.payload;
    },
    setSupaUniqueEmployees: (state, action: PayloadAction<string[]>) => {
      state.uniqueEmployees = action.payload;
    },
  },
});

export const {
  setSupaCompanies,
  setSupaLoading,
  setSupaError,
  setSupaUniqueCategories,
  setSupaUniqueEmployees,
} = supaCompaniesSlice.actions;

export default supaCompaniesSlice.reducer;